/**
 * Changes made:
 * - 2025-09-27: Created BottomRightVector component for hero section bottom-right vector shape
 */

export const BottomRightVector = () => {
  return (
    <div 
      data-svg-wrapper 
      data-layer="Vector 6" 
      className="Vector6 left-[868px] top-[157px] absolute"
    >
      <svg width="378" height="382" viewBox="0 0 378 382" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M258 382.5H0L205 0L378 318H312L205 142.5L175 200.5L258 382.5" fill="hsl(var(--hero-vector-bottom))" />
      </svg>
    </div>
  );
};